/* eslint-disable react-refresh/only-export-components */

// src/contexts/AuthContext.jsx
import React, { createContext, useEffect, useState } from 'react';
import endpoints from '../api/endpoints';
import AuthService, { refreshAccessToken, setAccessToken } from '../api/axiosInstance';

export const AuthContext = createContext(null);

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [userLoading, setUserLoading] = useState(false);

  const fetchCurrentUser = async ({ showLoading = true } = {}) => {
    if (showLoading) {
      setUserLoading(true);
    }
    try {
      const res = await AuthService.get(endpoints.CURRENT_USER);
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      if (showLoading) {
        setUserLoading(false);
      }
    }
  };

  useEffect(() => {
    refreshAccessToken()
      .then(() => fetchCurrentUser({ showLoading: false }))
      .catch(() => {})
      .finally(() => {
        setLoadingUser(false);
      });
  }, []);

  const login = async ({ email, password }) => {
    const res = await AuthService.post(endpoints.LOGIN, { email, password });

    setAccessToken(res.data.access);

    await fetchCurrentUser({ showLoading: true });
  };

  const logout = async () => {
    try {
      await AuthService.post(endpoints.LOGOUT);
    } catch (err) {
      console.warn("Logout failed:", err);
    } finally {
      setAccessToken(null);
      window.location.href = "/";
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, loadingUser, userLoading, login, logout, fetchCurrentUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
